/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import DocumentVerification from "./DocumentVerification.container";

export default DocumentVerification;
